import utils from "Sources/utils/utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/sessions/session-custom-material-item.html";

import "Styles/components/mission-shared-user.scss";

class CustomMaterialsListItem
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.material = options.material;
    this.onRemoved = options.onRemoved;
    this.usesRemoveButton = options.usesRemoveButton;
    this.usesCheckbox = options.usesCheckbox;
    this.disableInput = options.disableInput;
    this.hideInput = options.hideInput;
    this.material.amount = options.material.maxAmount;
    this.material.selected = options.selected;
  }

  get material()
  {
    return this._material;
  }

  set material(material)
  {
    this._material = material;
    this.updateCustomMaterialsListItem();
  }

  static setUpCustomMaterialsListItem(options)
  {
    let instance = new CustomMaterialsListItem(options);
    instance.render();
    instance.setOriginalAmount();
    instance.setInitialState(instance.material.amount);
    instance.setUpEventListeners();

    return instance;
  }

  setInitialState(selected)
  {
    if(selected)
    {
      this.$element.find(".material-checkbox").prop("checked", true);
      this.$element.find(".amount-input").val(this.material.amount).trigger("change");
    }
    else
    {
      this.$element.find(".material-checkbox").prop("checked", true);
      this.$element.find(".amount-input").val(0);
    }
  }

  setUpEventListeners()
  {
    const REMOVE_BTN_ID = ".remove-btn";
    const AMOUNT_FIELD_ID = ".amount-input";
    const CHECKBOX_ID = ".material-checkbox";

    let that = this;
    this.$element.find(REMOVE_BTN_ID).on("click", function(e)
    {
      that.removeMaterial();
    });

    this.$element.find(AMOUNT_FIELD_ID).on("change", function(e)
    {
      that.setAmount(that.$element.find(AMOUNT_FIELD_ID).val());
    });

    this.$element.find(CHECKBOX_ID).on("change", function(e)
    {
      if(e.target.checked)
      {
        that.material.selected = true;
        that.material.amount = parseInt(that.$element.find(AMOUNT_FIELD_ID).val());
      }
      else
      {
        that.material.selected = false;
        that.material.amount = 0;
      }
    });
  }

  setAmount(amount)
  {
    this.material.amount = amount;
  }

  setOriginalAmount()
  {
    if(utils.isNotNull(this.material.amount))
    {
      this.$element.find(".amount-input").val(this.material.amount).trigger("change");
    }
  }

  removeMaterial()
  {
    this.onRemoved(this.material.key, this.material.name);
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);
    this.updateCustomMaterialsListItem();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateCustomMaterialsListItem() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $materialName = this.$element.find("[data-bind-target='material-name-label']");
      $materialName.empty();
      if (utils.isNotNull(this.material) && utils.isNotNull(this.material.name)) {
        $materialName.text(this.material.name);
        $materialName.attr("for", "material-checkbox-" + this.material.key);

      }


      let $materialCheckbox = this.$element.find("[data-bind-target='material-checkbox']");
      if(this.usesCheckbox)
      {
        $materialCheckbox.empty();

        if (utils.isNotNull(this.material) && utils.isNotNull(this.material.key)) {
          $materialCheckbox.attr("id", "material-checkbox-" + this.material.key);
        }

        $(".custom-control-label").removeClass("no-before");
      }
      else
      {
        $(".custom-control-label").addClass("no-before");
      }

      let $removeButton = this.$element.find(".remove-btn");
      if(this.usesRemoveButton)
      {
        $removeButton.show();
      }
      else
      {
        $removeButton.hide();
      }

      let $amountInput = this.$element.find(".amount-input");
      if (utils.isNotNull(this.material.maxAmount)) {
        $amountInput.val(this.material.amount)
        $amountInput.attr("max", this.material.maxAmount);
      }

      if(this.disableInput)
      {
        $amountInput.prop( "disabled", true );
      }
      else
      {
        $amountInput.prop( "disabled", false );
      }

      if(this.hideInput)
      {
        $amountInput.hide();
      }
      else
      {
        $amountInput.show();
      }


    }
  }

}

export default CustomMaterialsListItem;



// WEBPACK FOOTER //
// ./app/js/components/custom-materials-list-item.js